import { liveTicker } from "@/mocks/home";

export default function LiveBar() {
  return (
    <section className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto flex w-full max-w-[1280px] items-center gap-3 overflow-hidden px-4 py-2.5 md:px-6">
        <div className="flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500 px-2.5 py-1 text-xs font-semibold text-foreground-950">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-foreground-950/60" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-foreground-950" />
          </span>
          直播更新
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-[marquee_46s_linear_infinite] items-center gap-10 whitespace-nowrap px-2">
            {[...liveTicker, ...liveTicker].map((t, i) => (
              <span key={i} className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="shrink-0 rounded-sm bg-background-100 px-1.5 py-px text-[11px] text-primary-600">
                  {t.time}
                </span>
                {t.text}
                <i className="ri-flashlight-line ml-6 text-foreground-300" />
              </span>
            ))}
          </div>
        </div>
        <a
          href="#"
          onClick={(e) => e.preventDefault()}
          className="hidden shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap text-xs text-primary-600 hover:text-primary-700 sm:flex"
        >
          查看全部
          <i className="ri-arrow-right-line" />
        </a>
      </div>
    </section>
  );
}